import { types } from "../types/types";

const initialState = {
    tipoEfectores: [],
    subtipoEfectores: [],
    loading: false
};

export const TipoEfectoresReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.tipoEfectoresTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.tipoEfectoresTraerSuccess:
            return {
                ...state,
                tipoEfectores: action.payload,
                loading: false
            }
        case types.tipoEfectoresTraerError:
            return {
                ...state,
                tipoEfectores: [],
                loading: false
            }
        case types.subtipoEfectoresTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.subtipoEfectoresTraerSuccess:
            return {
                ...state,
                subtipoEfectores: action.payload,
                loading: false
            }
        case types.subtipoEfectoresTraerError:
            return {
                ...state,
                tipoEfectores: [],
                subtipoEfectores: false
            }
        default:
            return state;
    }
};
